import { PropsWithChildren, useMemo } from 'react';

import { ClientContext, ClientContextProps } from './client-context';
import QueryProvider from './QueryProvider';
import axios from 'axios';

type ClientProviderProps = ClientContextProps;

export default function ClientProvider({ children, accessToken, basePath }: PropsWithChildren<ClientProviderProps>) {
  return useMemo(
    () => (
      <ClientContext.Provider
        value={{
          accessToken,
          basePath,
        }}
      >
        <QueryProvider>{children}</QueryProvider>
      </ClientContext.Provider>
    ),
    [children, accessToken, basePath],
  );
}

axios.interceptors.response.use(
  (r) => {
    if (!r) return Promise.reject(new Error('No response'));
    return r.data;
  },
  (e) => Promise.reject(e),
);
